import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table'
import { Helmet } from "react-helmet";
import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'




function Cshistory(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
 
return(
    <div>
      <Sides/>
      
<Helmet>
 
<title>Learn Free PHP History Tutorials For Beginners CodeExampler</title>
<meta name="description" content="Php History tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like Php tutorial, Php tutorial,Php tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,tutorial for begineers,php release history,php version history,Php history,Learn Programming Online " />
<link rel="canonical" href="https://www.codeexampler.com/php-history" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php History</h1>
    <div className="first">
    <a href="/php-user-define-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-introduction">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">
1, Php programming languages were designed by Rasmus Lerdorf in 1994<br/>
2, Php 8.0 Version Present Release on 26/11/2020 <br/>
3, Php implementation "Personal Home Page/Forms Interpreter" or PHP/FI.

</p>
<h2 className="mt-4 mh2">Php version history</h2>

    <Table  striped bordered hover responsive variant="dark" className="m-4">
  <thead>
    <tr>
      <th></th>
      <th colSpan="1">Php Versions</th>
      <th >Php Versions release date</th>
   
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1.0</td>
      <td>Php Version 1.0</td>
      <td>08/06/1995</td>
    </tr>
    <tr>
      <td>2.0</td>
      <td>Php Version 2.0</td>
      <td>01/11/1997</td>
     
    </tr>
    <tr>
      <td>3.0</td>
      <td>Php Version  3.0</td>
      <td>6/06/1998</td>
     
    </tr>
    <tr>
      <td>4.0</td>
      <td>Php Version 4.0</td>
      <td>22/05/2000</td>
     
    </tr>

    <tr>
      <td>4.1</td>
      <td>Php Version 4.1</td>
      <td>10/12/2001</td>
     
    </tr>

    <tr>
      <td>4.2</td>
      <td>Php Version 4.2</td>
      <td>22/04/2020</td>
     
    </tr>

    <tr>
      <td>4.3</td>
      <td>Php Version 4.3</td>
      <td>27/12/2002</td>
     
    </tr>


    <tr>
      <td>4.4</td>
      <td>Php Version 4.4 </td>
      <td>11/07/2005</td>
     
    </tr>

    <tr>
      <td>5.0</td>
      <td>Php Version 5.0</td>
      <td>13/07/2004</td>
     
    </tr>

    <tr>
      <td>5.1</td>
      <td>Php Version 5.1</td>
      <td>24/11/2005</td>
     
    </tr>
    <tr>
      <td>5.2</td>
      <td>Php Version 5.2</td>
      <td>02/11/2006</td>
     
    </tr>
    <tr>
      <td>5.3</td>
      <td>Php Version 5.3</td>
      <td>30/06/2009</td>
     
    </tr>

    <tr>
      <td>5.4</td>
      <td>Php Version 5.4</td>
      <td>01/03/2012</td>
     
    </tr>

    <tr>
      <td>5.5</td>
      <td>Php Version 5.5</td>
      <td>20/07/2013</td>
     
    </tr>

    <tr>
      <td>5.6</td>
      <td>Php Version 5.6</td>
      <td>28/08/2014</td>
     
    </tr>


    <tr>
      <td>6.x</td>
      <td>Php Version 6.x</td>
      <td>N/A</td>
     
    </tr>

    <tr>
      <td>7.0</td>
      <td>Php Version 7.0</td>
      <td>03/12/2015</td>
     
    </tr>


    <tr>
      <td>7.1</td>
      <td>Php Version 7.1</td>
      <td>01/12/2016</td>
     
    </tr>

    <tr>
      <td>7.2</td>
      <td>Php Version 7.2</td>
      <td>30/11/2017</td>
     
    </tr>
    <tr>
      <td>7.3</td>
      <td>Php Version 7.3</td>
      <td>06/12/2018</td>
     
    </tr>
    <tr>
      <td>7.4</td>
      <td>Php Version 7.4</td>
      <td>28/11/2019</td>
     
    </tr>

    <tr>
      <td>8.0</td>
      <td>Php Version 8.0</td>
      <td>26/11/2020</td>
     
    </tr>

  </tbody>
</Table>



  <h1 className="mt-5">  </h1>
  <div className="back">
  <a href="/php-user-define-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-introduction">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cshistory;